/*
 * PortUNA Framework (http://www.portuna.de/)
 *
 * @author     Grandke, Luke <grandke@portuna.de>
 * @copyright  PortUNA Neue Medien GmbH (http://www.portuna.de)
 * @created    24.3.2025 14:6 Uhr
 */

export const EMPLOYEE_API_AGENDA = 1;